/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const coolingHVACEnumsCurrentStatusOptionEnum = {
    Online: 'Online',
    Offline: 'Offline',
    Busy: 'Busy',
    Overwhelmed: 'Overwhelmed',
    Saturated: 'Saturated',
    Other: 'Other',
} as const;

export type CoolingHVACEnumsCurrentStatusOptionEnumKey =
    (typeof coolingHVACEnumsCurrentStatusOptionEnum)[keyof typeof coolingHVACEnumsCurrentStatusOptionEnum];

export type CoolingHVACEnumsCurrentStatusOption = CoolingHVACEnumsCurrentStatusOptionEnumKey;
